/**
 * package: com.inq.flash.client.chatskins
 * class: CoBrowseMgr
 * root Object
 * @constructor
 */
com.inq.flash.client.chatskins.CoBrowseMgr = function() {};

/**
 * init
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function init():Void
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.CoBrowseMgr.init = function() {
	com.inq.flash.client.chatskins.CoBrowseMgr.customerAcceptsCobrowse = _getLocalizedMessage("customerAcceptsCobrowse");
	com.inq.flash.client.chatskins.CoBrowseMgr.customerDeclinesCobrowse = _getLocalizedMessage("customerDeclinesCobrowse");
	com.inq.flash.client.chatskins.CoBrowseMgr.customerAcceptsSharedControl = _getLocalizedMessage("customerAcceptsSharedControl");
	com.inq.flash.client.chatskins.CoBrowseMgr.customerDeclinesSharedControl = _getLocalizedMessage("customerDeclinesSharedControl");
	com.inq.flash.client.chatskins.CoBrowseMgr.customerEndCobrowseSession = _getLocalizedMessage("customerEndCobrowseSession");
	com.inq.flash.client.chatskins.CoBrowseMgr.agentEndCobrowseSession = _getLocalizedMessage("agentEndCobrowseSession");
	com.inq.flash.client.chatskins.CoBrowseMgr.cobrowseUnexpectedFail = _getLocalizedMessage("cobrowseUnexpectedFail");
	com.inq.flash.client.chatskins.CoBrowseMgr.cobrowseSuppressed = _getLocalizedMessage("cobrowseSuppressed");
	com.inq.flash.client.chatskins.CoBrowseMgr.notSupportedBrowser = "CoBrowse cannot be accepted because the client browser is not supported."; // agent has never sent the cobrowse invitation for old browsers
	com.inq.flash.client.chatskins.CoBrowseMgr.cobrowseTestSuccess =
		com.inq.utils.Util.getConfig("cobrowseTestSuccessMsg", _getLocalizedMessage("cobrowseTestSuccess"));
	com.inq.flash.client.chatskins.CoBrowseMgr.cobrowseTestFail =
		com.inq.utils.Util.getConfig("cobrowseTestFailMsg", _getLocalizedMessage("cobrowseTestFail"));

	//Add access for rulesgen FlashPeer to ci functions
	//NOTE: name should been started with "ci" characters
	com.inq.flash.client.control.FlashPeer.setCiFunction("ciAcceptCobInv",com.inq.flash.client.chatskins.CoBrowseMgr.acceptCobInv);
	com.inq.flash.client.control.FlashPeer.setCiFunction("ciDeclineCobInv",com.inq.flash.client.chatskins.CoBrowseMgr.declineCobInv);
	com.inq.flash.client.control.FlashPeer.setCiFunction("ciAcceptCobShareInv",com.inq.flash.client.chatskins.CoBrowseMgr.acceptCobShareInv);
	com.inq.flash.client.control.FlashPeer.setCiFunction("ciDeclineCobShareInv",com.inq.flash.client.chatskins.CoBrowseMgr.declineCobShareInv);
	com.inq.flash.client.control.FlashPeer.setCiFunction("ciCheckCobrowseMgrAvalibility",function() { return true; });
	com.inq.flash.client.control.FlashPeer.setCiFunction("ciAgentEndsCob",com.inq.flash.client.chatskins.CoBrowseMgr.agentEndsCob);
	com.inq.flash.client.control.FlashPeer.setCiFunction("ciSendCobrowseEnded",com.inq.flash.client.chatskins.CoBrowseMgr.sendCobrowseEnded);
	com.inq.flash.client.control.FlashPeer.setCiFunction("ciSendMessageQuietly",com.inq.flash.client.chatskins.CoBrowseMgr.sendMessageQuietly);
	com.inq.flash.client.control.FlashPeer.setCiFunction("ciFocusCobEndBtn",com.inq.flash.client.chatskins.CoBrowseMgr.focusCobEndBtn);
	com.inq.flash.client.control.FlashPeer.setCiFunction("ciCobrowseSuppressedPage",com.inq.flash.client.chatskins.CoBrowseMgr.cobrowseSuppressedPage);
	com.inq.flash.client.control.FlashPeer.setCiFunction("ciCobrowseFailHandler",com.inq.flash.client.chatskins.CoBrowseMgr.cobrowseFailHandler);
	com.inq.flash.client.control.FlashPeer.setCiFunction("ciSendResultOfBenchmarkTest",com.inq.flash.client.chatskins.CoBrowseMgr.sendResultOfBenchmarkTest);
	com.inq.flash.client.control.FlashPeer.setCiFunction("ciSetFocusOnChatInputField",com.inq.flash.client.chatskins.CoBrowseMgr.setFocusOnChatInputField);
	com.inq.flash.client.control.FlashPeer.setCiFunction("ciGetCobEndButtonID",com.inq.flash.client.chatskins.CoBrowseMgr.getCobEndButtonID);

	/*
	 * RTDEV-15590
	 * Added the following statements to allow cobrowse script calling cobrowse functions without
	 * "inqFrame.Inq.FlashPeer", which will be privatized and not accessible.
	 * The script should prepend the path with "window.inqFrame" in order for it to work on both
	 * desktop and mobile devices. For mobile devices, the owner of the script element is the parent page
	 * document and therefore "window.inqFrame" is required.
	 * We use the short published path name to help shorten the script.
	 */
	com.inq.utils.Util.publish("ciAcceptCobInv",com.inq.flash.client.chatskins.CoBrowseMgr.acceptCobInv);
	com.inq.utils.Util.publish("ciDeclineCobInv",com.inq.flash.client.chatskins.CoBrowseMgr.declineCobInv);
	com.inq.utils.Util.publish("ciAcceptCobShareInv",com.inq.flash.client.chatskins.CoBrowseMgr.acceptCobShareInv);
	com.inq.utils.Util.publish("ciDeclineCobShareInv",com.inq.flash.client.chatskins.CoBrowseMgr.declineCobShareInv);
	com.inq.utils.Util.publish("ciActionBtnCloseChat",com.inq.flash.client.chatskins.CoBrowseMgr.closeChat);
	com.inq.utils.Util.publish("ciActionRestoreAndExitChat",com.inq.flash.client.chatskins.CoBrowseMgr.restoreAndExitChat);

	com.inq.utils.Util.publish("com.inq.flash.client.chatskins.CoBrowseMgr.stopCob", com.inq.flash.client.chatskins.CoBrowseMgr.stopCob);
	com.inq.utils.Util.publish("com.inq.flash.client.chatskins.CoBrowseMgr.sendCobrowseEnded", com.inq.flash.client.chatskins.CoBrowseMgr.sendCobrowseEnded);
	com.inq.utils.Util.publish("com.inq.flash.client.chatskins.CoBrowseMgr.setFocusOnChatInputField", com.inq.flash.client.chatskins.CoBrowseMgr.setFocusOnChatInputField);

	com.inq.flash.client.chatskins.CoBrowseMgr.cobEndButtonID = com.inq.utils.Util.getConfig("cobEndButtonID", "tcChat_cobend");
	com.inq.flash.client.chatskins.CoBrowseMgr.btnCobEndHTML = com.inq.utils.Util.getConfig("cobEndButton", "");
    /*
     * RTDEV-17960
     * Calls CBC to reset the csq number.
     */
	if(Inq && Inq["CBC"]) {
		if(typeof Inq["CBC"].resetCSQ == "function") {
			Inq["CBC"].resetCSQ();
		}
	}
	function _getLocalizedMessage(key) {
		return com.inq.flash.client.control.FlashPeer.getLocalizedMessage(key);
	}
};

com.inq.flash.client.chatskins.CoBrowseMgr.getCobEndButtonID = function () {
	return com.inq.flash.client.chatskins.CoBrowseMgr.cobEndButtonID;
}

/**
 * Accessibility help to do list when Cobrowse accepted message is received
 */
com.inq.flash.client.chatskins.CoBrowseMgr.ariaCobStart = function (replay) {
    var cbMgr = com.inq.flash.client.chatskins.CoBrowseMgr;
    cbMgr.addCobEndButton();
	// temporary disable modal window
	if (com.inq.flash.client.control.MinimizeManager.minimized !== true) {
		com.inq.flash.client.chatskins.SkinControl.hideModalWindow(false);
	}
	/*
	 * For requirements, see RTDEV-17299
	 * Set focus for Minimize button (only for phones) after the customer accepts cobrowse invitation.
	 * The delay is set  because the screen reader has to first readout the banner
	 */
	if (com.inq.utils.Capabilities.isPhone() && "1" != replay) {
		window.setTimeout(function() {
			cbMgr.focusMinimizedBtn();
		}, 5000);
	}
};

/**
 * Accessibility help to do list when Cobrowse ended message is received
 */
com.inq.flash.client.chatskins.CoBrowseMgr.ariaCobEnd = function () {
	com.inq.flash.client.chatskins.CoBrowseMgr.removeCobEndButton();
	if (com.inq.flash.client.control.MinimizeManager.minimized !== true) {
		com.inq.flash.client.chatskins.SkinControl.hideModalWindow(true);
	}
};

/**
 * Add endcob button on persistent window.
 */
com.inq.flash.client.chatskins.CoBrowseMgr.addCobEndButton = function () {
 	if (com.inq.flash.client.control.FlashPeer.isPersistentWindow() && document.getElementById(com.inq.flash.client.chatskins.CoBrowseMgr.cobEndButtonID) == null) {
		var btnCobEnd = document.createElement('div');
		btnCobEnd.innerHTML = com.inq.flash.client.chatskins.CoBrowseMgr.btnCobEndHTML;
		var chatDiv = document.getElementById("chat");
		if(chatDiv) {
			chatDiv.appendChild(btnCobEnd);
		}
	}
	com.inq.aria.AriaMsg.addAriaMsg(com.inq.utils.Util.getConfig("cobSessionStartMsg", "You're being assisted"))
};

com.inq.flash.client.chatskins.CoBrowseMgr.closeChat = function(e) {
	com.inq.flash.client.chatskins.SkinControl.actionBtnCloseChat(e);
};

com.inq.flash.client.chatskins.CoBrowseMgr.restoreAndExitChat = function(e) {
	com.inq.flash.client.chatskins.SkinControl.actionRestoreAndExitChat(e);
};

/**
 * Remove cob button on persistent window
 */
com.inq.flash.client.chatskins.CoBrowseMgr.removeCobEndButton = function () {
	var cobEnd = document.getElementById(com.inq.flash.client.chatskins.CoBrowseMgr.cobEndButtonID);
	if (cobEnd != null) {
		try	{
			var div_cobend = cobEnd.parentNode;
			div_cobend.parentNode.removeChild(div_cobend);
		} catch (e) {
			cobEnd.parentNode.style.display = "none";
		}
	}
};

/**
 * stop Cob session and remove endbutton on persistent window
 *
 * @see inqFrame.com.inq.flash.client.chatskins.CoBrowseMgr.stopCob()
 */
com.inq.flash.client.chatskins.CoBrowseMgr.stopCob = function () {
	if (Inq["CBM"]) {
		Inq.CBM.endCobrowse();
		if (com.inq.flash.client.control.FlashPeer.isPersistentWindow()) {
			Application.application.setFocusOnInputField();
		}
	}
};

/**
 * stop Cob session and remove endbutton on persistent window
 *
 * @see inqFrame.com.inq.flash.client.chatskins.CoBrowseMgr.stopCob()
 */
com.inq.flash.client.chatskins.CoBrowseMgr.setFocusOnChatInputField = function () {
	if( !(com.inq.flash.client.control.FlashPeer.isPersistentWindow() && com.inq.utils.Util.isIE) ) {
		Application.application.setFocusOnInputField();
	}
};

/**
 * Send result about benchmark test to the agent. The message is stored in chat transcript.
 *
 * @param {string} messageText message with execution time of benchmark test in milliseconds
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.CoBrowseMgr.sendResultOfBenchmarkTest = function(messageText) {
    // this message should NEVER be shown to the consumer (request from the business/product manager)
    Application.application.applicationController.sendCoBrowseMessageQuietly(messageText, com.inq.flash.client.data.MessageFields.KEY_COBROWSE_EVENT_TYPE_CLIENT_PERFORMANCE_TEST);
};

/**
 * If the browser is overloaded, com.inq.flash.client.chatskins.SkinControl.getApplicationController() returns undefined.
 *
 * @private
 * @static
 * @return {boolean}
 */
com.inq.flash.client.chatskins.CoBrowseMgr._isConnectionExist = function() {
	try {
		return Application.application.applicationController.isConnected();
	} catch (e) {
		return false;
	}
}

/**
 * Upon cbc fail, stop CoBrowse and send detail message to AI
 * Remarks: 1) The message was sent to the agent as quiet (hidden for user).
 *          2) The operation is not executed if no connection.
 *
 * @public
 * @param  failMsg    fail message
 * @return {boolean}  true if message is sent to AI
 */
com.inq.flash.client.chatskins.CoBrowseMgr.cobrowseFailHandler = function (failMsg) {
	if (!failMsg) {
		failMsg = com.inq.flash.client.chatskins.CoBrowseMgr.cobrowseUnexpectedFail;
	}
	if (com.inq.flash.client.control.FlashPeer.isCobrowseEngaged()) {
		com.inq.flash.client.control.FlashPeer.endCob();
	}
	var sentMsg = false;
	if (com.inq.flash.client.chatskins.CoBrowseMgr._isConnectionExist()) {
		Application.application.applicationController.sendCoBrowseMessageQuietly(failMsg,
			com.inq.flash.client.data.MessageFields.KEY_COBROWSE_EVENT_TYPE_CLIENT_COBROWSE_END);
		sentMsg = true;
	}
	return sentMsg;
};

/**
 * Send message to the agent that cobrowse is suppressed on the page. The message is stored in transcript.
 * Remark: The operation is not executed if no connection.
 *
 * @public
 * @static
 * @return {boolean}  true if message is sent to AI
 */
com.inq.flash.client.chatskins.CoBrowseMgr.cobrowseSuppressedPage = function() {
	if (!com.inq.flash.client.chatskins.CoBrowseMgr._isConnectionExist()) {
		return false;
	} else {
        // this message should NEVER be shown to the consumer.
		Application.application.applicationController.sendCoBrowseMessageQuietly(com.inq.flash.client.chatskins.CoBrowseMgr.cobrowseSuppressed, com.inq.flash.client.data.MessageFields.KEY_COBROWSE_EVENT_TYPE_CLIENT_COBROWSE_SUPPRESSED);
        return true;
	}
};

com.inq.flash.client.chatskins.CoBrowseMgr.getCobrowseEnableHighlight = function() {
	try {
		return Inq["getEnableHighlight"]();
	} catch (e) {
		haxe.Log.trace(e,{ fileName : "CobrowseMgr.js", lineNumber : 160, className : "com.inq.flash.client.chatskins.CoBrowseMgr", methodName : "getCobrowseEnableHighlight"});
		return true; // highlight should be possible by default
	}
};

/**
 * @RTDEV-15837: Agent Minimize/Restore button (Mobile Cobrowse)
 *  This function determines if the Minimize & Restore buttions on the AI - Cobrowse should be visible  based on the two conditions:
 *  1) if the client device is mobile (a phone or a tablet)
 *  2) if the flag on the portal is set to true
 */
com.inq.flash.client.chatskins.CoBrowseMgr.getCobrowseEnableMinimizeRestore = function() {
	try {
		if (com.inq.utils.Capabilities.isMobile() && com.inq.flash.client.control.FlashPeer.getCobrowseEnableMinimizeRestore()) {
			return true;
		}
	} catch (e) {
		haxe.Log.trace(e,{ fileName : "CobrowseMgr.js", lineNumber : 212, className : "com.inq.flash.client.chatskins.CoBrowseMgr", methodName : "getCobrowseEnableMinimizeRestore"});
	}
	return false; // Minimize & Restore buttons should be hidden by default
};

/**
 * show Cob banner.
 */
com.inq.flash.client.chatskins.CoBrowseMgr.showCobBanner = function() {
	if(!com.inq.flash.client.control.FlashPeer.isPersistentWindow() && Inq["CBM"] && Inq["CBM"]["banner"]) {
		Inq["CBM"]["banner"]["show"]();
		window.setTimeout(com.inq.flash.client.chatskins.CoBrowseMgr.focusCobEndBtn, 500);
	}
};

/**
 * show Cob banner.
 */
com.inq.flash.client.chatskins.CoBrowseMgr.focusCobEndBtn = function() {
	var btnCobend = com.inq.ui.Container._getElementById("tcChat_cobend",window.parent.document);
	if(btnCobend != null) btnCobend.focus();
};

/**
 * Set focus on Minimized button.
 */
com.inq.flash.client.chatskins.CoBrowseMgr.focusMinimizedBtn = function() {
	// Minimize button id can be either minimize or btnMinimize.
	var _app = Application.application;
	var btnMinimized = _app.getButton("minimize") || _app.getButton("btnMinimize") ;
	if (btnMinimized != null) {
		btnMinimized.setImageFocus();
	}
};

/**
 * Accept cobrowse invitation.
 *
 * @public
 * @static
 * @param flagStartBenchmarkTest flag to start Benchmark Test
 * @return {void}
 */
com.inq.flash.client.chatskins.CoBrowseMgr.acceptCobInv = function(flagStartBenchmarkTest) {
	if(com.inq.flash.client.control.FlashPeer.isCobrowseEngaged()) return;
	if(!com.inq.flash.client.chatskins.CoBrowseMgr.isSupportedBrowser()) return;
	Application.application.applicationController.sendCoBrowseMessage(com.inq.flash.client.chatskins.CoBrowseMgr.customerAcceptsCobrowse,
		                                                                                      com.inq.flash.client.data.MessageFields.KEY_COBROWSE_EVENT_TYPE_CLIENT_COBROWSE_ACCEPT,
		                                                                                      com.inq.flash.client.chatskins.CoBrowseMgr.getCobrowseEnableHighlight(),
                                                                                              com.inq.flash.client.chatskins.CoBrowseMgr.getCobrowseEnableMinimizeRestore());
	com.inq.flash.client.chatskins.CoBrowseMgr.showCobBanner();
	com.inq.flash.client.control.FlashPeer.acceptCobInvSafe(flagStartBenchmarkTest);
};
/*
 function to check if this is in Persistent Window and cannot reach Inq in client window

 closePersistent

 */

/**
 * Decline cobrowse invitation.
 *
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.CoBrowseMgr.declineCobInv = function(event) {
	/*
	 * RTDEV-17845
	 * The fix for this issue requires the cobrowse script to send both "click" and "touchstart" events like below:
	 *
	 * <a href="#" coboff="" onclick="window.inqFrame.com.inq.flash.client.chatskins.CoBrowseMgr.acceptCobInv(); return false;">accept cobrowse</a>
	 * <a href="#" ontouchstart="inqFrame.Inq.FlashPeer.ciDeclineCobInv(event)"
	 *             onclick="inqFrame.Inq.FlashPeer.ciDeclineCobInv(event)">decline cobrowse
	 * </a>
	 * Where:
	 * ontouchstart will be used for mobile devices and
	 * onclick will be used for desktop browser.
	 * The reason for doing that is desktop browser does not support TouchEvent and iOS (iphone & ipad) have problem
	 * with mouse click event.
	 */
	var cap = com.inq.utils.Capabilities;
	if ((cap.isIphone() || cap.isIpad()) && event) {
		event.preventDefault();
	}
	/**
	 * @see RTDEV-16010
	 * @description: Cobrowse Declined, Focus Lost (CHAT-828 CATO Defect #157)
	 */
	Application.application.setTextFieldfocus();
	if(com.inq.flash.client.control.FlashPeer.isCobrowseEngaged()) return;
	Application.application.applicationController.sendCoBrowseMessage(com.inq.flash.client.chatskins.CoBrowseMgr.customerDeclinesCobrowse,com.inq.flash.client.data.MessageFields.KEY_COBROWSE_EVENT_TYPE_CLIENT_COBROWSE_DECLINE);
};


/**
 * Accept cobrowse share invitation.
 *
 * @public
 * @static
 * @param flagStartBenchmarkTest flag to start Benchmark Test
 * @return {void}
 */
com.inq.flash.client.chatskins.CoBrowseMgr.acceptCobShareInv = function(flagStartBenchmarkTest) {
	if(com.inq.flash.client.control.FlashPeer.isCobrowseSharedControl()) return;
	if(!com.inq.flash.client.chatskins.CoBrowseMgr.isSupportedBrowser()) return;
	Application.application.applicationController.sendCoBrowseMessage(com.inq.flash.client.chatskins.CoBrowseMgr.customerAcceptsSharedControl,
                                                                                             com.inq.flash.client.data.MessageFields.KEY_COBROWSE_EVENT_TYPE_CLIENT_COBROWSE_ACCEPT_SHARE,
                                                                                             com.inq.flash.client.chatskins.CoBrowseMgr.getCobrowseEnableHighlight(),// Note that highlighteneabled will anyways be set to true for shared cobrowse session
                                                                                             com.inq.flash.client.chatskins.CoBrowseMgr.getCobrowseEnableMinimizeRestore());
	com.inq.flash.client.chatskins.CoBrowseMgr.showCobBanner();
	com.inq.flash.client.control.FlashPeer.acceptCobShareInv(flagStartBenchmarkTest);
};


/**
 * Decline cobrowse share invitation.
 *
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.CoBrowseMgr.declineCobShareInv = function(event) {
	/**
	 * @see description from declineCobInv for details.
	 */
	var cap = com.inq.utils.Capabilities;
	if ((cap.isIphone() || cap.isIpad()) && event) {
		event.preventDefault();
	}
    /**
     * @see RTDEV-16010
     * @description: Cobrowse Declined, Focus Lost (CHAT-828 CATO Defect #157)
     */
    Application.application.setTextFieldfocus();
	if(com.inq.flash.client.control.FlashPeer.isCobrowseSharedControl()) return;
	Application.application.applicationController.sendCoBrowseMessage(com.inq.flash.client.chatskins.CoBrowseMgr.customerDeclinesSharedControl,com.inq.flash.client.data.MessageFields.KEY_COBROWSE_EVENT_TYPE_CLIENT_COBROWSE_DECLINE_SHARE);
};


/**
 * End cobrowse.
 *
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.CoBrowseMgr.endCob = function() {
	if(!com.inq.flash.client.control.FlashPeer.isCobrowseEngaged()) return;
	com.inq.flash.client.chatskins.CoBrowseMgr.sendCobrowseEnded();
	com.inq.flash.client.control.FlashPeer.endCob();
};


/**
 * Agent ends cobrowse.
 *
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.CoBrowseMgr.agentEndsCob = function() {
	//if(!com.inq.flash.client.control.FlashPeer.isCobrowseEngaged()) return; // see RTDEV-17087
	Application.application.applicationController.sendCoBrowseMessage(com.inq.flash.client.chatskins.CoBrowseMgr.agentEndCobrowseSession, com.inq.flash.client.data.MessageFields.KEY_COBROWSE_EVENT_TYPE_AGENT_COBROWSE_END_MESSAGE_FROM_CI);
	com.inq.flash.client.control.FlashPeer.endCob();
};

/**
 * End cobrowse by ETL event.
 *
 * @public
 * @static
 * @param {string} windowId
 * @return {void}
 */
com.inq.flash.client.chatskins.CoBrowseMgr.endCobByEtlEvent = function (windowId) {
	if (!com.inq.flash.client.control.FlashPeer.isCobrowseEngaged()) {
		return;
	}
	com.inq.flash.client.control.FlashPeer.endCobByEtlEvent(windowId);
};

/**
 * Send cobrowse message to agent that cobrowse was ended by customer.
 *
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.CoBrowseMgr.sendCobrowseEnded = function() {
	Application.application.applicationController.sendCoBrowseMessage(com.inq.flash.client.chatskins.CoBrowseMgr.customerEndCobrowseSession,com.inq.flash.client.data.MessageFields.KEY_COBROWSE_EVENT_TYPE_CLIENT_COBROWSE_END);
};

/**
 * Send message quietly (without any message to customer).
 *
 * Send a message to agent and at the same time not display it to chat window.
 *
 * @public
 * @static
 * @param message  - string message to send
 * @return {void}
 */
com.inq.flash.client.chatskins.CoBrowseMgr.sendMessageQuietly = function( message ) {
	Application.application.applicationController.sendCoBrowseMessageQuietly(
		message, com.inq.flash.client.data.MessageFields.KEY_COBROWSE_EVENT_TYPE_CLIENT_COBROWSE_ACCEPT);
	// TODO create new constant for sending Alert
};

/**
 * isSupportedBrowser
 *
 *  This function calles getClientBrowserVersion to get browser name and version, then determines if
 *     Cobrowse is supported.
 *  return false if browser is IE 9 or earlier
 *  If false, send notSupportedBrowser message to Agent.
 *
 * @private
 * @static
 * @return {boolean}
 */
com.inq.flash.client.chatskins.CoBrowseMgr.isSupportedBrowser = function() {

	var result = true;
	try {
		var browInfo = com.inq.flash.client.control.FlashPeer.getBrowserTypeAndVersion();
		var browName = browInfo[0];
		var browVer = browInfo[1];

		// only IE 9 or earlier is identified unsupported browser for Cobrowse at the time of writing this code.
		if (browName === "MSIE" && parseInt(browVer.split(".")[0]) <= 9) {
			result = false;
		}
	} catch (e) {
		result = false;
	}

	// Send agent that the browser test has been failed
	if (result === false) {
		Application.application.applicationController.sendCoBrowseMessageQuietly(
			com.inq.flash.client.chatskins.CoBrowseMgr.notSupportedBrowser,
			com.inq.flash.client.data.MessageFields.KEY_COBROWSE_EVENT_TYPE_CLIENT_COBROWSE_END);
	}
	return result;
};


/** @private @type {string} */
com.inq.flash.client.chatskins.CoBrowseMgr.customerAcceptsCobrowse = null;

/** @private @type {string} */
com.inq.flash.client.chatskins.CoBrowseMgr.customerDeclinesCobrowse = null;

/** @private @type {string} */
com.inq.flash.client.chatskins.CoBrowseMgr.customerAcceptsSharedControl = null;

/** @private @type {string} */
com.inq.flash.client.chatskins.CoBrowseMgr.customerDeclinesSharedControl = null;

/** @private @type {string} */
com.inq.flash.client.chatskins.CoBrowseMgr.customerEndCobrowseSession = null;

/** @private @type {string} */
com.inq.flash.client.chatskins.CoBrowseMgr.agentEndCobrowseSession = null;

/** @private @type {string} */
com.inq.flash.client.chatskins.CoBrowseMgr.cobrowseUnexpectedFail = null;

/** @private @type {string} */
com.inq.flash.client.chatskins.CoBrowseMgr.cobrowseSuppressed = null;

/** @private @type {string} */
com.inq.flash.client.chatskins.CoBrowseMgr.cobrowseTestSuccess = null;
com.inq.flash.client.chatskins.CoBrowseMgr.cobrowseTestFail = null;
